import * as types from '../../mutation-types'
import axios from "axios";

export const saveCurlStatus = async ({ commit }, formData) => {
    const { data } = await axios.post(process.env.API_URL + '/save-curl-status', formData);
}

export const fetchCurls = async ({ commit }) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/get-curl-status');
        commit(types.FETCH_CURL_STATUS_SUCCESS, { data })
    } catch (e) {
        commit(types.FETCH_CURL_STATUS_FAILURE)
    }
}





// WEBPACK FOOTER //
// ./src/store/modules/curl/actions.js